import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  input,
  Renderer2,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';
import { filter, tap } from 'rxjs';
import { MenuTool } from '../../interfaces/MenuTool.interface';
import { NavigationItem } from '../../interfaces/navigationList.interface';
import {
  HomeButtonConfig,
  Profile,
} from '../../interfaces/PageContainerConfiguration.interface';
import { PageContainerService } from '../../services/page-container.service';
import { AppsToolsMenuComponent } from '../apps-tools-menu/apps-tools-menu.component';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { AuthenticationService } from '../../../../auth/services/authentication.service';
import { AboutModalService } from '../../services/aboutModal.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'st-side-menu-bar',
    imports: [
        TooltipModule,
        CommonModule,
        IconButtonComponent,
        AppsToolsMenuComponent,
        MenuModule,
        RouterModule,
    ],
    templateUrl: './side-menu-bar.component.html',
    styleUrls: ['./side-menu-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SideMenuBarComponent implements AfterViewInit {
  navigationList = input.required<NavigationItem[]>();
  homeButton = input<HomeButtonConfig>();
  tools = input.required<MenuTool[]>();
  profile = input.required<Profile>();
  settingURL = input<string>();
  isProfilePage = input<boolean>(false);

  public isAboutModalVisible = signal<boolean>(false);
  public userName = signal<string>('');
  public userEmail = signal<string>('');
  dropDownItems: MenuItem[] = [];
  constructor(
    readonly pageContainerService: PageContainerService,
    readonly router: Router,
    private readonly _renderer: Renderer2,
    private readonly _router: Router,
    public authenticationService: AuthenticationService,
    private readonly aboutModalService: AboutModalService,
    private readonly _cd: ChangeDetectorRef,
    private readonly _sharedService: SharedService,
  ) {
    this.setUserDetailsFromLocalStorage();
  }

  private setUserDetailsFromLocalStorage(): void {
    const currentUser = localStorage.getItem('currentUser');

    if (currentUser) {
      const user = JSON.parse(currentUser);

      // Get user name from firstName and lastName
      const userName =
        (user?.firstName && user?.lastName
          ? `${user.firstName} ${user.lastName}`
          : null) ??
        user?.firstName ??
        'Unknown User';

      // Get user email
      const userEmail = user?.email ?? 'Unknown Email';

      this.userName.set(userName);
      this.userEmail.set(userEmail);

      this.dropDownItems = [
        {
          items: [
            {
              label: 'About Adroit',
              icon: 'icon-info',
              shortcut: '⌘+a',
              disabled: false,
              command: () => this.aboutModalService.openAboutModal(),
            },
            {
              label: 'Sign Out',
              icon: 'icon-sign-out',
              shortcut: '⌘+d',
              disabled: false,
              styleClass: 'danger',
              command: () => this.signOut(),
            },
          ],
        },
      ];
    }
  }

  isHomeButtonActive = signal(false);
  routerEvents$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    tap(event => {
      const homeButton = this.homeButton();
      if (homeButton && event.urlAfterRedirects === homeButton.routeUrl) {
        this.isHomeButtonActive.set(true);
      } else {
        this.isHomeButtonActive.set(false);
      }
    }),
  );

  isExpandedMenu = signal<boolean>(false);

  ngAfterViewInit() {
    const homeButton = this.homeButton();
    if (homeButton && this.router.url === homeButton.routeUrl) {
      this.isHomeButtonActive.set(true);
    } else {
      this.isHomeButtonActive.set(false);
    }
  }

  expandMenu() {
    this.isExpandedMenu.update(x => !x);
    this.pageContainerService.menuExpanded.next(this.isExpandedMenu());
  }

  goToHome(url: string) {
    this.pageContainerService.activeSectionRoute.next(null);
  }

  public toggleMenu(event: Event, menu: Menu) {
    menu.toggle(event);

    this._renderer.setStyle(
      menu.el.nativeElement,
      'top',
      `${(event as any).y}px !important`,
    );
    this._renderer.setStyle(
      menu.el.nativeElement,
      'left',
      `${(event as any).x}px !important`,
    );
  }

  public signOut() {
    this.authenticationService.removeUserData();
    this._router.navigate(['/login']);
  }
}
